import { Link } from 'react-router-dom';
import { Skull } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center space-y-6">
      <Skull className="w-16 h-16 text-parchment-muted/40" />
      <div>
        <h1 className="font-display text-5xl text-gold mb-2">404</h1>
        <p className="text-parchment text-xl">Page Not Found</p>
      </div>
      <p className="text-parchment-muted max-w-sm">
        This area of the realm has yet to be charted. The page you seek does not exist.
      </p>
      <Link to="/" className="btn-primary">Return to the Board</Link>
    </div>
  );
}
